import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { DiagnosticserviceService } from '../diagnosticservice.service';

@Component({
  selector: 'app-assign-diagnostic',
  templateUrl: './assign-diagnostic.component.html',
  styleUrls: ['./assign-diagnostic.component.scss']
})
export class AssignDiagnosticComponent {

  form: FormGroup;
  editForm: FormGroup;
  myform: FormGroup;
  breadCrumbItems: any;
  data: any;
  id: any;
  typesubmit: boolean;
  roomdata: any;
  patientdata: any;
  diagnosticdata: any;
  testlistArr: any = []
  grandtotal: number;
  assigneddata: any;
  diagnostictest: any;


  constructor(public formBuilder: UntypedFormBuilder, private myservice: DiagnosticserviceService, public route: ActivatedRoute, private router: Router, public datePipe: DatePipe, public modalService: NgbModal) {
    this.form = this.formBuilder.group({
      patient_type: ['', Validators.required],
      patient_id: ['', Validators.required],
      name: ['', Validators.required],
      last_name: ['', Validators.required],
      age: ['', Validators.required],
      gender: ['', Validators.required],
      address: ['', Validators.required],
      pymnt_type: ['', Validators.required],
      upiId: [""],
      discount: ['0'],
      // diagnostic_name: ['', Validators.required],
      // diagnostic_amount: ['', Validators.required],

    })

    this.myform = this.formBuilder.group({
      diagnostic_name: ['', Validators.required],
      diagnostic_amount: [''],
    });

    this.editForm = this.formBuilder.group({
      patient_type: [''],
      patient_id: [''],
      name: [''],
      last_name: [''],
      age: [''],
      gender: [''],
      address: [''],
      pymnt_type: [''],
      upiId: [""],
      discount: ['0'],
    })
  }

  ngOnInit(): void {
    this.breadCrumbItems = [{ label: 'Godavari wave Tech' }, { label: 'Assign Diagnostic Tests', active: true }];
    this.getappointmentdata();
    this.getdiagnosticdata();
    this.getassigndiagnostics();
  }

  gotoassigntest() {
    this.router.navigate(['/diagnostic/add-diagnostic']);
  }

  get type() {
    return this.form.controls;
  }


  getappointmentdata() {
    this.myservice.getappointments().subscribe((res: any) => {
      this.patientdata = res.data;
    });
  }

  onPatientIdChange(selectedPatientId: any, formGroup: FormGroup) {
    console.log('Patient ID selected:', selectedPatientId);

    const patientData = this.patientdata.find(patient => patient.patient_id === selectedPatientId); // Find patient data by ID

    if (patientData) {
      console.log('Matching patient data found:', patientData);
      formGroup.patchValue({
        name: patientData.name,
        last_name: patientData.last_name,
        age: patientData.age,
        gender: patientData.gender,
        address: patientData.address,
      });
    } else {
      console.log('No matching patient found');
    }
  }


  getdiagnosticdata() {
    this.myservice.getdiagnostics().subscribe((res: any) => {
      this.diagnosticdata = res.data;
    });
  }

  onDiagnosticNameChange(selectedDiagnosticName: any) {
    console.log('Diagnostic Name selected:', selectedDiagnosticName);

    const diagnosticData = this.diagnosticdata.find(v => v.id === selectedDiagnosticName.id); // Find diagnostic data by name

    if (diagnosticData) {
      console.log('Matching diagnostic data found:', diagnosticData);
      this.myform.patchValue({
        diagnostic_name: selectedDiagnosticName,
        diagnostic_amount: diagnosticData.diagnostic_amount, // Patch the diagnostic amount value
      });
    } else {
      console.log('No matching diagnostic found');
    }
  }

  adddiagnostictest() {
    if (!this.myform.value.diagnostic_name|| !this.myform.value.diagnostic_amount ) {
      Swal.fire('Select the Diagnostic Test')
    } else {
      this.testlistArr.push({
        'diagnostic_id': this.myform.value.diagnostic_name.id,
        'diagnostic_name': this.myform.value.diagnostic_name.name,
        'diagnostic_amount': this.myform.value.diagnostic_amount
      })

      let sum = 0;
      this.testlistArr.forEach((element) => {
        sum += parseFloat(element.diagnostic_amount);
      });
      this.grandtotal = sum;

      console.log(this.testlistArr);
      
      this.myform.reset();
     }
  }

  deleteTest(index: number) {
    // Remove the selected diagnostic test by index and recalculate the grand total in one step
    this.testlistArr.splice(index, 1);
    this.grandtotal = this.testlistArr.reduce((acc, item) => acc + parseFloat(item.diagnostic_amount), 0);
  }
  

  typeSubmit() {
    this.typesubmit = true;
    if (this.form.invalid) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Please Fill the Empty Field',
        showConfirmButton: false,
        timer: 1500
      })
    }else if (this.testlistArr.length == 0) {
      Swal.fire('Please Enter the Diagnostic Tests')
    } else {
      this.form.value.grandtotal = this.grandtotal;
      this.form.value.company_id = localStorage.getItem('company_id');
      var data = {
        form: this.form.value,
        testlistArr: this.testlistArr
      }
      this.myservice.assigndiagnostics(data).subscribe((res: any) => {
        console.log('Response from server:', res);
        if (res.status == 200) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Successfully Submitted',
            showConfirmButton: false,
            timer: 1500
          });
          this.typesubmit = false;
          this.form.reset();
          this.testlistArr = [];
          this.grandtotal = 0;
          this.getassigndiagnostics();

          // this.get();
        } else {
          console.log('Submission failed:', res);
          Swal.fire('Failed');
        }
      },(error) => {
        console.error('Error occurred:', error);
        Swal.fire('Submission Failed due to error');
        
      });
    }
  }

  reset() {
    this.form.reset()
  }

  getassigndiagnostics() {
    this.myservice.getassigndiagnostics().subscribe((res: any) => {
      this.assigneddata = res.data;
      
    });
  }

  close23() {
    this.modalService.dismissAll()
  }

  centerModal(centerDataModal: any, data) {
    console.log(data);

    this.editForm.patchValue({
      patient_type: data.patient_type,
      patient_id: data.patient_id,
      name: data.name,
      last_name: data.last_name,
      age: data.age,
      gender: data.gender,
      address: data.address,
      pymnt_type: data.pymnt_type,
      discount: data.discount,
      id: data.id,
    });
    this.id = data.id;
    this.modalService.open(centerDataModal, { centered: true, size: "lg" });
  }

  edit() {
    this.typesubmit = true;
    if (this.editForm.invalid) {
      alert("Please fill all details")
    } else
      var data = {
        company_id: localStorage.getItem("company_id"),
        id: this.id,
        patient_type: this.editForm.value.patient_type,
        patient_id: this.editForm.value.patient_id,
        name: this.editForm.value.name,
        last_name: this.editForm.value.last_name,
        age: this.editForm.value.age,
        gender: this.editForm.value.gender,
        address: this.editForm.value.address,
        pymnt_type: this.editForm.value.pymnt_type,
        upiId: this.editForm.value.upiId,
        discount: this.editForm.value.discount,
        
      };
     console.log(data);
     
    this.myservice.editasssigndiagnostics(data).subscribe((res: any) => {
      if (res.status == 200) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Successfully Updated",
          showConfirmButton: false,
          timer: 1500,
        });
        this.typesubmit = false;
        this.editForm.reset();
        this.modalService.dismissAll();
        this.getassigndiagnostics();
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Oops...",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  }


  Delete(i) {
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure to delete it ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.myservice.deleteassigndiagnostics(i).subscribe((res: any) => {
          if (res.status == 200) {
            this.getassigndiagnostics();
            ;
            Swal.fire({
              position: "top-end",
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success",
            });
          }
        });
      }
    });
  }

  gettestlist(value, content) {
    var data = {
        id:value,
        company_id: localStorage.getItem('company_id')
    }

    console.log(data);
    this.myservice.gettestlist(data).subscribe((res: any) => {
      this.diagnostictest = res.data;
      this.modalService.open(content, { centered: true });

    })
  }

  upi: boolean = false;

  selectfield(event) {
    // console.log(event);
    if (event == 'upi') {
      this.upi = true
    } else {
      this.upi = false
    };

  }


}
